/*
 * � 2020 Microsoft. All rights reserved.
 */

define('util/DetailedButton',['pixi', 'absolute', 'util/eventhandler'],
    function (PIXI, Absolute, EventHandler) {
        var DetailedButton = function (upTexture, overTexture, downTexture, selectTexture, disabledTexture) {
            this.upTexture = upTexture;
            this.downTexture = downTexture;
            this.overTexture = overTexture;
            this.selectTexture = selectTexture;
            this.disabledTexture = disabledTexture;
            this.interactive = true;
            this.onClick = new EventHandler();
            PIXI.Sprite.call(this, this.upTexture);
            this.bindListeners();

            this.disabled = false;
            this.selected = false;
            this.hasFocus = false;
        };

        DetailedButton.prototype = Object.create(PIXI.Sprite.prototype);
        DetailedButton.prototype.constructor = DetailedButton;

        DetailedButton.prototype.bindListeners = function () {
            this.interactive = true;
            this.buttonMode = true;

            if (Absolute.Platform.supportsTouch()) {
                this.bindTouchEvents();

                // Support mouse on laptops/desktops that have touch displays
                if (Absolute.Platform._isWindows()) {
                    this.bindMouseEvents();
                }
                // fix an issue on iOS devices in desktop mode
                else if (Absolute.Platform._isMac() && !Absolute.Platform._isIOS()) {
                    this.bindMouseEvents();
                }
            } else {
                this.bindMouseEvents();
            }
        };

        DetailedButton.prototype.bindTouchEvents = function () {
            this.touchstart = function (evt) {
                if ((this.selected && !this.isDropDownButton) || this.disabled) { return; }
                this.setTexture(this.downTexture);
            }.bind(this);

            this.touchend = function (evt) {
                if ((this.selected && !this.isDropDownButton) || this.disabled) { return; }
                this.setTexture(this.upTexture);
                this.handleInputUp();
            }.bind(this);

            this.touchendoutside = function (evt) {
                if ((this.selected && !this.isDropDownButton) || this.disabled) { return; }
                this.setTexture(this.upTexture);
            };
        };

        DetailedButton.prototype.bindMouseEvents = function () {
            this.mouseover = function (evt) {
                if (this.selected || this.disabled) { return; }
                this.setTexture(this.overTexture);
            };
            this.mouseout = function (evt) {
                if (this.selected || this.disabled) { return; }
                this.setTexture(this.upTexture);
            };

            this.mousedown = function (evt) {
                if ((this.selected && !this.isDropDownButton) || this.disabled) { return; }
                this.setTexture(this.downTexture);
            }.bind(this);

            this.mouseup = function (evt) {
                if ((this.selected && !this.isDropDownButton) || this.disabled) { return; }
                this.setTexture(this.overTexture);
                this.handleInputUp();
            }.bind(this);
        };

        DetailedButton.prototype.handleInputUp = function () {
            if ((this.selected && !this.isDropDownButton) || this.disabled) { return; }
            Absolute.AudioManager.playSound('button');
            this.onClick.handleEvent(this);
        };

        DetailedButton.prototype.handleActivate = function () {
            if ((this.selected && !this.isDropDownButton) || this.disabled) { return; }
            Absolute.AudioManager.playSound('button');
            this.onClick.handleEvent(this);
        };

        DetailedButton.prototype.toggle = function () {
            if (this.selected) { this.deselect(); }
            else { this.select(); };
        }

        DetailedButton.prototype.select = function () {
            if (this.disabled) { return; }
            this.selected = true;
            this.setTexture(this.selectTexture);
        };

        DetailedButton.prototype.deselect = function () {
            if (this.disabled) { return; }
            this.selected = false;
            if (this.hasFocus) {
                this.setTexture(this.overTexture);
            } else {
                this.setTexture(this.upTexture);
            }
        };

        DetailedButton.prototype.enable = function () {
            if (!this.disabled) { return; }
            this.disabled = false;
            this.setTexture(this.upTexture);
        };

        DetailedButton.prototype.disable = function () {
            if (this.disabled) { return; }
            this.disabled = true;
            this.setTexture(this.disabledTexture);
        };

        DetailedButton.prototype._focusChanged = function () {
            if (this.selected) { return; }

            if (this.hasFocus) {
                this.setTexture(this.overTexture);
            } else {
                this.setTexture(this.upTexture);
            }
        };

        Object.defineProperty(DetailedButton.prototype, "focus", {
            get: function () {
                return this.hasFocus;
            },
            set: function (value) {
                if (this.disabled) { return; }
                this.hasFocus = value;
                this._focusChanged();
                return value;
            }
        });

        return DetailedButton;
    }
);

